export const getEnvironment = (): 'DEV' | 'STAGE' | 'PROD' => {
    const hostname = window.location.hostname;
    if (hostname.includes('dev.') || hostname.includes('localhost')) {
        return 'DEV';
    }
    if (hostname.includes('stage.') || hostname.includes('staging.')) {
        return 'STAGE';
    }
    return 'PROD';
};

export const getUrlForEnvironment = (urls: {
    DEV: string;
    STAGE: string;
    PROD: string;
}): string => {
    const env = getEnvironment();
    return urls[env];
};

export const getBridgeEnvironment = (): 'LOCAL' | 'DEV' | 'STAGE' | 'PROD' => {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost')) {
        return 'LOCAL';
    }

    if (hostname.includes('dev.')) {
        return 'DEV';
    }
    if (hostname.includes('stage.') || hostname.includes('staging.')) {
        return 'STAGE';
    }
    return 'PROD';
};

export const getUrlForEnvironmentBridge = (urls: {
    LOCAL: string;
    DEV: string;
    STAGE: string;
    PROD: string;
}): string => {
    const env = getBridgeEnvironment();
    return urls[env];
};
